import React from 'react';
import { useSelector } from 'react-redux';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/common';
import { Swipe } from '../../common/assets/icons';
import { Usage360Guide } from './Usage360Guide';
import { View360Button } from './View360Button';
import { View360WrapperStyled } from './styled';
export function View360Control({ isView360GuideShowed, isView360ButtonShowed, btnRef, children, }) {
    const isRightToLeft = useSelector(getRTL);
    const labels = useSelector(getProductCardLabels);
    return (React.createElement(View360WrapperStyled, null,
        isView360GuideShowed && (React.createElement(Usage360Guide, { isRightToLeft: isRightToLeft, image: Swipe, text: labels.view360Hint })),
        isView360ButtonShowed && (React.createElement(View360Button, { labels: labels, isRightToLeft: isRightToLeft, btnRef: btnRef })),
        children));
}
